module.exports = __webpack_public_path__ + "img/new.16e4b33f.png";